import { compose } from "recompose";

import userRecoverPassword from "../../../../../hoc/persister/userRecoverPassword";
import { IUserRecoverPasswordProps } from "../../../../../hoc/persister/userRecoverPassword/userRecoverPassword";

import PasswordRecoveryFunnel, {
  IProps,
} from "./PasswordRecoveryFunnel.component";

type IInjectedProps = IUserRecoverPasswordProps;

type IContainerProps = Omit<IProps, keyof IInjectedProps>;

export default compose<IProps, IContainerProps>(userRecoverPassword)(
  PasswordRecoveryFunnel
);
